export class SCH001Params {
    CanScheduledMonth: number;
    AllowSameDaySameTimeSameDoctorDifferentRoom: number;
    CloseDateSec: string;
    CloseWeekDaySec: string;
    CloseMonthDay: string;
    CanScheduledTherapistMonth: boolean;
    TherapistLastRecord: string;
    TherapistScheduledNotify: boolean;
    TherapistScheduledRunning: number;  // 1: 固定首筆 2:輪流選入

}



export class TherapistLastRecordDto {
    RegDate: string = '';
    PT: string = '';
    OT: string = '';
    ST: string = '';
    PRT: string = '';

    /** string → TherapistLastRecordDto */
    static fromString(record?: string | null): TherapistLastRecordDto {
        const dto = new TherapistLastRecordDto();

        const today = TherapistLastRecordDto.today();

        if (!record) {
            dto.RegDate = today;
            return dto;
        }

        try {
            const obj = JSON.parse(record);

            dto.RegDate = obj.RegDate ?? '';

            const isSameDay = dto.RegDate === today;

            if (isSameDay) {
                dto.PT = obj.PT ?? '';
                dto.OT = obj.OT ?? '';
                dto.ST = obj.ST ?? '';
                dto.PRT = obj.PRT ?? '';
            } else {
                // RegDate 不符合今天 → 清空
                dto.clear();
                dto.RegDate = today;
            }
        } catch {
            // 非合法 JSON → 當成新的一天
            dto.clear();
            dto.RegDate = today;
        }

        return dto;
    }

    /** DTO → string */
    toString(): string {
        return JSON.stringify({
            RegDate: this.RegDate ?? '',
            PT: this.PT ?? '',
            OT: this.OT ?? '',
            ST: this.ST ?? '',
            PRT: this.PRT ?? ''
        });
    }

    /** 清空治療紀錄 */
    clear(): void {
        this.PT = '';
        this.OT = '';
        this.ST = '';
        this.PRT = '';
    }

    /** 今天 yyyy-MM-dd */
    public static today(): string {
        return new Date().toISOString().slice(0, 10);
    }
}
